import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type CommissionSummary = {
	_id?: string | null;
	repairs?: Array<unknown> | null;
	value?: number | null;
	totalMaterial?: number | null;
};

type AllCommissionsTableProps = {
	commissions?: CommissionSummary[];
};

export function AllCommissionsTable({
	commissions = [],
}: AllCommissionsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[180px]">Client</TableHead>
						<TableHead className="w-[180px]">Client</TableHead>
						<TableHead className="w-[180px]">Orçamento</TableHead>
						<TableHead className="w-[180px]">Material</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{commissions.map((entry) => {
						const rowKey = entry._id ?? "commission-row";
						const repairCount = entry.repairs?.length ?? 0;

						return (
							<TableRow key={rowKey}>
								<TableCell>{entry._id ?? "-"}</TableCell>
								<TableCell>{repairCount}</TableCell>
								<TableCell>{entry.value ?? 0}</TableCell>
								<TableCell>{entry.totalMaterial ?? 0}</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
